import { types } from 'mobx-state-tree';
import { useCreateStore, useProvider, useStore } from 'mobx-store-provider';
import { nanoid } from 'nanoid';
import React from 'react';

const PortalIdStore = types.model('PortalIdStore', {
  portalId: types.string,
});

export const usePortalIdStore = () => useStore(PortalIdStore);

export const withPortalId = (Component) => (props) => {
  const Provider = useProvider(PortalIdStore);
  const store = useCreateStore(PortalIdStore, {
    portalId: nanoid(),
  });

  return (
    <Provider value={store}>
      <Component {...props} />
    </Provider>
  );
};
